// 🔧 volunteer_seeder.js
// ✅ Purpose: Seeds Volunteer Engine demo data into Firestore
// ✅ Features:
// - Coordinates persistence of volunteer demo data
// - Resolves event identity from the canonical Demo Engine eventResult contract
// - Calls the repository layer only
// - No Firestore logic in this file
// - No demo data generation
// - Returns standardized results to the Builder
// - Fully block-commented for clarity and future devs

import { saveVolunteerData } from "./volunteer_repository";

export const seedVolunteers = async ({
  demoContext,
  volunteerPlan,
} = {}) => {
  console.log("🌱 Volunteer Seeder started.");

  // =====================================================
  // ✅ Resolve the canonical Demo Engine event identifier.
  // =====================================================
  // Event Builder stores its complete result on
  // demoContext.eventResult. Volunteer Engine follows the same
  // contract used by Core builders and the other add-on engines.
  // =====================================================

  const eventId =
    demoContext?.eventResult?.eventId;

  if (!eventId) {
    throw new Error(
      "Volunteer Seeder requires demoContext.eventResult.eventId."
    );
  }

  if (!volunteerPlan) {
    throw new Error(
      "Volunteer Seeder requires volunteerPlan."
    );
  }

  // =====================================================
  // Persist volunteer demo data.
  // =====================================================

  const results = await saveVolunteerData({
    eventId,
    volunteerPlan,
  });

  console.log("✅ Volunteer Seeder completed.", {
    activities: results.activities.length,
    timeSlots: results.timeSlots.length,
  });

  return results;
};